import { environment } from '../../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('TourOptionService', TourOptionService);

  TourOptionService.$inject = [
    'RestResource',
    '$translate',
    '$filter',
    'UtilService',
    'TranslationModalService',
    'TourModalService',
    'ModalWindowConfirmService',
  ];

  function TourOptionService(
    RestResource,
    $translate,
    $filter,
    UtilService,
    TranslationModalService,
    TourModalService,
    ModalWindowConfirmService
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'tours';

    var service = {
      openTourOptionModal: openTourOptionModal,
      getTourOption: getTourOption,
      saveTourOption: saveTourOption,
      deleteTourOption: deleteTourOption,
      changeTourOptionStatus: changeTourOptionStatus,
      openTourOptionTranslation: openTourOptionTranslation,
    };

    return service;

    ////////////////

    function openTourOptionModal(
      tour,
      item,
      defaultLanguage,
      additionalLanguages,
      successCallback
    ) {
      TourModalService.openTourOption(
        tour,
        item,
        defaultLanguage,
        additionalLanguages,
        successCallback
      );
    }

    function getTourOption(tourId, itemId, language, translate) {
      var params = { lang: null, get: null };

      if (language) {
        params.lang = language;
      }

      if (translate) {
        params.get = 'translate';
      }

      var url = apiUrl + '/' + tourId + '/tour_options/' + itemId;

      return RestResource.request(
        'get',
        url,
        params,
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function saveTourOption(tourId, item, language) {
      var method = item.id ? 'put' : 'post';
      var url = apiUrl + '/' + tourId + '/tour_options';
      url = item.id ? url + '/' + item.id : url;

      function success(response) {
        var msg = item.id ? 'MODIFIED_TOUR_OPTION' : 'NEW_ADDED_TOUR_OPTION';
        utils._successMsg($translate(msg));

        return {
          status: true,
          response: response.data,
        };
      }

      function failure(response) {
        return {
          status: false,
          response: response.data,
        };
      }

      return RestResource.request(
        method,
        url,
        { tour_option: item, lang: language },
        success,
        failure
      );
    }

    function changeTourOptionStatus(tourId, option) {
      var url = apiUrl + '/' + tourId + '/tour_options/' + option.id;

      var params = {
        successMsg: 'MODIFIED_TOUR_OPTION',
      };

      utils.changeItemStatus(url, option, params);
    }

    function deleteTourOption(tour, option, successCallback) {
      var modalParams = {
        mode: 'danger',
        title: 'DELETE_TOUR_OPTION',
        itemName: option.name,
        reason: 'DELETE_ITEM_REASON',
        confirmButtonLabel: 'DELETE_TOUR_OPTION',
      };

      var confirmCallback = function (reasonStatus) {
        var url = apiUrl + '/' + tour.id + '/tour_options/' + option.id;

        function success() {
          var msg = $translate('TOUR_OPTION_DELETED');
          utils._successMsg(msg);

          return successCallback();
        }
        function failure(response) {
          utils._errorMsg(response.data.error);
        }

        return RestResource.request(
          'delete',
          url,
          { reason_status: reasonStatus },
          success,
          failure
        );
      };

      ModalWindowConfirmService.open(modalParams, confirmCallback);
    }

    function openTourOptionTranslation(tourId, item, additionalLanguages) {
      var template = './app/ajs/tours/tour-options/modals/tour-option-detail-translation.html';

      var modalParams = {
        //title: tourName +': '+ item.name,
        title: item.name,
        item: item,
        additionalLanguages: additionalLanguages,
      };

      var initializeCallback = function (itemId, language) {
        return getTourOption(tourId, itemId, language, 'translate').then(function (data) {
          return data;
        });
      };

      var confirmCallback = function (item, language) {
        return saveTourOption(tourId, item, language).then(function (data) {
          if (!data.status) {
            return data.response;
          }

          return false;
        });
      };

      TranslationModalService.open(template, modalParams, initializeCallback, confirmCallback);
    }
  }
})();
